module.exports = __webpack_public_path__ + "media/connect.387e7a9e.mp3";